import React from 'react'
import { StaticImage } from 'gatsby-plugin-image'

import '../../static/styles/footer-banner.css'

export default () => (
  <div className="">
    <div className="container padded">
      <section className="row" id="final-cta">
        <div className="col-12">
          <div className="cta-card">
            <div className="row">
              <div className="col-12 col-md-6 offset-xl-1 col-xl-5">
                <h2>Start Sending Today</h2>
                <p>
                  Put all our pro features to the test in your free 14-day trial.
                </p>
              </div>
              <div className="col-12 col-md-6 offset-xl-1 col-xl-3 d-flex flex-column justify-content-center align-items-start align-items-md-center align-items-xl-end">
                <div className="link-group">
                  <div className="d-flex justify-content-between g2-badge-container">
                    <StaticImage
                      className="img-fluid g2-badge"
                      src="../../static/assets/g2_high_performer.png"
                      width={84}
                      height={109}
                      alt="Momentum Leader"
                    />
                    <StaticImage
                      className="img-fluid g2-badge"
                      src="../../static/assets/g2_momentum_leader.png"
                      width={84}
                      height={109}
                      alt="High Performer Small Business Winter"
                    />
                  </div>
                  <a
                    title="Get Started"
                    href="https://next.quickmail.com/signup"
                    className="btn btn-primary purple-btn"
                  >
                    Get Started
                  </a>
                  <small>GROW WITH BETTER COLD OUTREACH</small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
)
